// src/services/keycloakService.js
import Keycloak from "keycloak-js";

let keycloak = null;

const initKeycloak = (keycloakConfig, initOptions) => {
  keycloak = new Keycloak(keycloakConfig);
  return keycloak.init(initOptions);
};

const getKeycloak = () => {
  return keycloak;
};

const isAuthenticated = () => {
  return keycloak?.authenticated || false;
};

const getToken = () => {
  return keycloak?.token;
};

const updateToken = () => {
  if (keycloak && keycloak.authenticated) {
    return keycloak.updateToken();
  }
  return Promise.reject(
    new Error("Keycloak not initialized or not authenticated")
  );
};

const logout = () => {
  if (keycloak) {
    return keycloak.logout();
  }
  return Promise.reject(new Error("Keycloak not initialized"));
};

const login = () => {
  if (keycloak) {
    return keycloak.login();
  }
  return Promise.reject(new Error("Keycloak not initialized"));
};

export {
  keycloak,
  initKeycloak,
  getKeycloak,
  isAuthenticated,
  getToken,
  updateToken,
  logout,
  login,
};
